import { Signature } from './interfaces/fiscalResponse.interface';

export const getVivaAuthenticationCode = (signatures: Signature[]): string => {
  const item = signatures?.find((it) => it.caption === 'authenticationCode');

  return item?.data || '';
};

export const getVivaLicenseKey = (signatures: Signature[]): string => {
  const item = signatures?.find((it) => it.caption === 'www.viva.com');
  if (item?.data) return `${item.data} (www.viva.com)`;

  return '';
};

export const getVivaUniqueDocId = (signatures: Signature[]): string => {
  const item = signatures?.find((it) => it.caption === 'Μοναδικός αριθμός παραστατικού');

  return item?.data || '';
};
